import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";

const DOCUMENTS = [
  {
    index: "01",
    title: "Условия обработки персональных данных по поручению",
    to: "/legal/data-processing",
  },
  {
    index: "02",
    title: "Согласие на обработку персональных данных, разрешённых для распространения",
    to: "/legal/publication-consent",
  },
  {
    index: "03",
    title: "Публичная оферта",
    to: "/legal/offer",
  },
  {
    index: "04",
    title: "Согласие на получение рекламных и информационных сообщений",
    to: "/legal/marketing-consent",
  },
  {
    index: "05",
    title: "Согласие на обработку персональных данных",
    to: "/legal/ru-personal-data-consent",
  },
  {
    index: "06",
    title: "Политика конфиденциальности и обработки персональных данных",
    to: "/legal/privacy",
  },
];

export default function LegalCenter() {
  return (
    <main
      className="min-h-screen bg-[#F4EDDF] text-[#35281F]"
      data-testid="legal-center-page"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0"
        style={{
          background:
            "radial-gradient(circle at 18% 8%, rgba(255,255,255,0.68), transparent 34%), linear-gradient(180deg, rgba(255,255,255,0.16) 0%, rgba(119,86,57,0.03) 100%)",
        }}
      />

      <div className="relative mx-auto w-full max-w-[1120px] px-5 pb-12 pt-5 sm:px-7 md:px-10 md:pb-16 md:pt-8">
        <header className="flex items-center justify-between border-b border-[#715B49]/20 pb-4">
          <div className="font-serif text-[15px] tracking-[0.08em] text-[#4A382C]">
            ANOKINA STUDIO
          </div>
          <Link
            to="/"
            className="group inline-flex min-h-[40px] items-center gap-2 rounded-full border border-[#715B49]/28 bg-[#FAF6EE]/80 px-4 text-[12px] tracking-[0.06em] text-[#5B493B] transition-colors hover:bg-[#FFF9F0]"
          >
            <ArrowLeft className="h-3.5 w-3.5" strokeWidth={1.5} />
            На платформу
          </Link>
        </header>

        <section className="pb-10 pt-12 md:pb-14 md:pt-16">
          <div>
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#8B725E]">
              Правовой центр
            </p>
            <h1 className="mt-4 max-w-[720px] font-serif text-[42px] leading-[0.98] text-[#2F241D] sm:text-[52px] md:text-[64px]">
              Правовая
              <br />
              информация
            </h1>
            <p className="mt-6 max-w-[720px] text-[15px] leading-7 text-[#6B5848] md:text-[16px]">
              Действующие юридические документы цифровой платформы Anokina Studio.
              Здесь собраны актуальные редакции условий, согласий и политики обработки данных.
            </p>
          </div>
        </section>

        <section aria-labelledby="legal-documents-title">
          <div className="mb-5 flex items-end justify-between border-b border-[#715B49]/22 pb-3">
            <h2
              id="legal-documents-title"
              className="font-serif text-[24px] text-[#3A2D24] md:text-[28px]"
            >
              Документы
            </h2>
            <span className="hidden text-[10px] uppercase tracking-[0.2em] text-[#9A816B] sm:block">
              Актуальные редакции
            </span>
          </div>

          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 md:gap-4">
            {DOCUMENTS.map((doc) => (
              <Link
                key={doc.to}
                to={doc.to}
                className="group relative min-h-[138px] overflow-hidden rounded-[18px] border border-[#6E5846]/28 bg-[#FAF6ED]/88 px-5 py-5 shadow-[0_3px_16px_rgba(72,51,35,0.05)] transition-all duration-300 hover:-translate-y-[1px] hover:bg-[#FFF9F1] hover:shadow-[0_8px_28px_rgba(72,51,35,0.09)] md:min-h-[148px] md:px-5 md:py-5 lg:min-h-[154px]"
              >
                <span
                  aria-hidden="true"
                  className="pointer-events-none absolute inset-[5px] rounded-[14px] border border-[#6E5846]/16"
                />
                <div className="relative flex h-full flex-col">
                  <div className="flex items-start justify-between gap-4">
                    <span className="font-serif text-[13px] tracking-[0.12em] text-[#A08469]">
                      {doc.index}
                    </span>
                    <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[#7B6451]/25 bg-white/45 text-[#6B5443] transition-transform duration-300 group-hover:translate-x-[2px] group-hover:-translate-y-[2px]">
                      <ArrowUpRight className="h-3.5 w-3.5" strokeWidth={1.45} />
                    </span>
                  </div>
                  <h3 className="mt-4 max-w-[94%] font-serif text-[19px] leading-[1.16] text-[#3A2D24] md:text-[20px] lg:text-[19px] xl:text-[20px]">
                    {doc.title}
                  </h3>
                </div>
              </Link>
            ))}
          </div>
        </section>

        <footer className="mt-12 flex flex-col gap-3 border-t border-[#715B49]/20 pt-5 text-[11px] leading-5 text-[#846F5C] sm:flex-row sm:items-center sm:justify-between md:mt-16">
          <span>© Anokina Studio</span>
          <span>Правовой центр цифровой платформы</span>
        </footer>
      </div>
    </main>
  );
}
